import { GET, POST, POSTNEW, download, UPLOADINGNEW, uploading, POSTFormData, EXPORTNEW, uploadingImg, DELETENEW, GETNEW } from '@/request/http'

// 申诉信息分页查询
export const getAppealData = p => POSTNEW('/studentgrowthfiles/punishmentremove/get/punishmentRemoveInfo', p)

// 驳回
export const saveRegectlData = p => POSTNEW('/studentgrowthfiles/punishmentremove/applyReject', p)

// 修改处分等级
export const modifiedAppeal = p => POSTNEW('/studentgrowthfiles/punishmentremove/updateMistakeGrade', p)

// 撤销处分
export const revokeAppeal = p => GETNEW('/studentgrowthfiles/studentPunishment/repeal', p)

// 新的撤销处分
export const repealPunishInfo = p => POSTNEW('/studentgrowthfiles/studentPunishment/repealPunishInfo', p)

// 学工修改违纪事实，违纪条款
export const changeMistakeFactAndRules = p => POSTNEW('/studentgrowthfiles/studentPunishment/updatePunish', p)


// WEBPACK FOOTER //
// ./src/api/modules/appeal.js